export default {

  validateNewCustomer(vm) {

    vm.sendingForm = true;

    vm.customer.cpf_cnpj_clean = vm.cpfCnpjClean;

    axios.post('/api/assistance/validate-new-customer', vm.customer)
      .then((response) => {

        //sucesso
        if (response.data.isCustomer && !response.data.isAlreadyRegistered) {
          vm.customerCanRegister = true;
        } else if (response.data.isCustomer && response.data.isAlreadyRegistered){
          swal(
            'Ooops...',
            'Você já possui um usuário cadastrado na área restrita, basta realizar o login para acesso.',
            'warning'
          );
        } else {
          swal(
            'Ooops...',
            'Seu cadastro não foi encontrado, por favor entre em contato conosco pelo telefone (11) 2394-9844',
            'warning'
          );
        }

        vm.sendingForm = false;

      })
      .catch(function (error) {

        alert('ops');

        // if (error.response.status === 422) {
        //
        //   let errosValidacao = error.response.data.errors;
        //
        //   let campos = Object.keys(errosValidacao);
        //
        //   let arrayErros = [];
        //
        //   campos.forEach((campo) => {
        //
        //     arrayErros.push(errosValidacao[campo][0]);
        //
        //   });
        //
        //   swal('Ooops...', arrayErros.join('\n'), 'error');
        //
        //   vm.sendingForm = false;
        //
        // }

      });
  },


  saveCustomer(vm) {

    vm.sendingForm = true;

    vm.customer.cpf_cnpj_clean = vm.cpfCnpjClean;

    axios.post('/api/assistance/save-customer', vm.customer)
      .then((response) => {

        //sucesso
        if (response.data.status) {

          //redirect to panel
          window.location.href = '/assistance/home';

        }

        vm.sendingForm = false;

      })
      .catch(function (error) {

        alert('ops');

        // if (error.response.status === 422) {
        //
        //   let errosValidacao = error.response.data.errors;
        //
        //   let campos = Object.keys(errosValidacao);
        //
        //   let arrayErros = [];
        //
        //   campos.forEach((campo) => {
        //
        //     arrayErros.push(errosValidacao[campo][0]);
        //
        //   });
        //
        //   swal('Ooops...', arrayErros.join('\n'), 'error');
        //
        //   vm.sendingForm = false;
        //
        // }

      });
  },

};
